import styled, { createGlobalStyle } from 'styled-components';
import 'react-toastify/dist/ReactToastify.min.css';
import { Button } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-rrule-generator/build/styles.css';

export const PrimaryBtn = styled(Button).attrs(props => ({
  className: 'component-btn component-focus flex-row align-center',
}))`
  border: none;
  outline: none;
  justify-content: space-between !important;
  background-color: #185335 !important;
  width: 110px !important;
  padding: 15px !important;
  color: white !important;
`;

export default createGlobalStyle`

@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding-top: 60px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body,
#root {
  height: 100%;
}
code {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.full-fixed {
  position: fixed;
  width: 100%;
}

.max-fixed {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.flex-1 {
  display: flex;
  flex: 1;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-row-reverse {
  display: flex;
  flex-direction: row-reverse;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.justify-center {
  justify-content: center;
}

.justify-around {
  justify-content: space-around;
}

.justify-between {
  justify-content: space-between;
}

.justify-evenly {
  justify-content: space-evenly;
}

.justify-stretch {
  justify-content: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.align-center {
  align-items: center;
}

.align-stretch {
  align-items: stretch;
}

.align-start {
  align-items: flex-start;
}

.align-end {
  align-items: flex-end;
}

.self-align-start {
  align-self: flex-start;
}

.self-align-end {
  align-self: flex-end;
}

.self-align-center {
  align-self: center;
}

.self-align-stretch {
  align-self: stretch;
}

.self-justify-start {
  justify-self: flex-start;
}

.self-justify-end {
  justify-self: flex-end;
}

.self-justify-center {
  justify-self: center;
}

.self-justify-stretch {
  justify-self: stretch;
}

.content-center {
  width: 80%;
}

.weight-bold {
  font-weight: bold;
}

.ck.ck-content.ck-editor__editable {
  min-height: 500px;
}

.component-focus {
  position: relative;
}

.component-focus:hover {
  cursor: pointer;
}

.component-focus::after {
  position: absolute;
  display: block;
  content: '';
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0);
  -webkit-transition: background-color 0.2s ease;
  -moz-transition: background-color 0.2s ease;
  -o-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.component-focus:hover::after {
  background-color: rgba(255, 255, 255, 0.2);
}

.container {
  margin: 10px auto;
  width: 100%;
  max-width: 750px;
  padding: 10px 2%;
}

.img-circle {
  border-radius: 50%;
}

.m-1 {
  margin: 10px;
}

.mr-1 {
  margin-right: 10px;
}

.mr-2 {
  margin-right: 20px !important;
}

.w-50 {
  width: 50%;
}
.w-40 {
  width: 40%;
}
.w-60 {
  width: 60%;
}

.w-33 {
  width: 33%;
}

.w-25{
  width: 25%;
}

.pointer {
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.btn-primary {
  background: #185335;
  border: 0;
  width: 90px;
}

.btn-rounded {
  padding: 10px;
  border-radius: 10px;
}

.header-menu {
  height: 70px;
  background-color: #000000;
}

.header-menu-logo {
  text-decoration: none;
}

.header-menu-logo-img {
  width: 52px;
  height: 50px;
}

.header-menu-logo-text {
  font-size: 23px;
  font-weight: bold;
  color: #FFFFFF;
  margin-left: 10px;
  margin-bottom: 0px;
}

.header-menu-center-content {
  padding: 20px;
}

.header-menu-user-logged-in {
  position: relative;
  padding: 10px;
}

.header-menu-user-logged-in:hover {
  cursor: pointer;
}

.header-menu-item {
  position: relative;
  padding-bottom: 10px;
  font-size: 16px;
  height: 20px;
  color: #FFFFFF;
  text-align: center;
  margin-left: 70px;
  margin-right: 10px;
  text-decoration: none;
}

.header-menu-item:hover {
  cursor: pointer;
}

.header-button {
  color: #000000;
  font-color: #FFFFFF;
  font-size: 16px !important;
  height: 80px;
}

@media all and (min-width: 701px) {
  .header-menu-item::after {
    position: absolute;
    left: 0;
    bottom: -5px;
    display: block;
    content: '';
    width: 100%;
    border-bottom: 3px solid #FFFFFF;
    -webkit-transform: scaleX(0);
    -ms-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 300ms ease-in-out;
    transition: transform 300ms ease-in-out;
  }

  .header-menu-item:hover::after {
    -webkit-transform: scaleX(1);
    -ms-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.login-modal-container {
  max-width: 80%;
  min-width: 250px;
  max-width: 400px;
}

.login-modal-container p {
  font-size: 23px;
  font-weight: bold;
}

.login-modal-container .login-modal-divider {
  flex: 1;
  border-bottom: 1px solid #AAAAAA;
  margin-top: 3px;
}

.login-modal-container div p {
  margin: 0 10px;
  font-size: 15px;
  line-height: 0;
}

.clipping-resume-modal-container {
  max-width: 90%;
  min-width: 600px;
}

.clipping-resume-modal-container-edit {
  max-width: 80%;
  min-width: 600px;
  margin-left: 10%;
}

.opacity-modal {
  z-index: 23;
  background-color: rgba(0,0,0,0.4);
}

.opacity-modal-title {
  font-size: 16px;
  margin-top: 10px;
  border: none;
  font-weight: bold;
}

.opacity-modal i.close {
  padding: 3px 7px;
  border-radius: 5px;
  color: #000;
  -webkit-transition: background-color 0.2s ease, color 0.2s ease;
  -moz-transition: background-color 0.2s ease, color 0.2s ease;
  -o-transition: background-color 0.2s ease, color 0.2s ease;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.opacity-modal i.close:hover {
  background-color: rgba(200,200,200,0.2);
  color: #888888 !important;
  cursor: pointer;
}
.component-btn {
  position: relative;
  color: #FFF;
  font-size: 14px;
  font-weight: bold;
  margin-left: 10px;
  padding: 10px;
  border-radius: 5px;
  text-decoration: none;
  justify-content: center;
}

.component-btn:hover {
  color: #DDDDDD;
  cursor: pointer;
}

.component-btn img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.juslabore-footer {
  min-height: 70px;
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;
  margin-top: 20px;
}

.component-input {
  border-bottom: 1px solid #AAAAAA;
  margin: 15px 15px 0;
  max-width: 100%;
}

.component-input input {
  flex: 1;
  text-decoration: none;
  outline: none;
  border: none;
  height: 30px;
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  background-color: transparent;
}

.component-input input::placeholder {
  font-size: 18px;
  color: #555;
  font-weight: 100;
}

.component-link {
  color: #FFF;
  font-size: 14px;
  font-weight: bold;
  margin-left: 10px;
  padding: 0;
  text-decoration: none;
}

.component-link:hover {
  color: #AAAAAA;
  cursor: pointer;
}
.search-component {
}

.bg-primary{
  background-color: #185335;
}

.h-100{
  height: 100%;
}
.search-input {
  color: #FFFFFF;
  outline: none;
  border: none;
  border-bottom: 2px solid #FFFFFF;
  background-color: transparent;
  font-size: 16px;
  padding: 5px 10px;
}

.search-icon {
  padding: 5px;
}

.search-icon {
  padding: 3px 7px;
  border-radius: 5px;
  -webkit-transition: background-color 0.2s ease, color 0.2s ease;
  -moz-transition: background-color 0.2s ease, color 0.2s ease;
  -o-transition: background-color 0.2s ease, color 0.2s ease;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.search-icon:hover {
  background-color: rgba(255,255,255,0.2);
  color: #DDDDDD;
  cursor: pointer;
}

a{
  text-decoration: none;
  color: inherit;
}

table{
  border:1px solid black;
  text-align: center;
}
.custom-modal{
  max-width: 90%;
  margin-top: 100px;
}
@media all and (max-width: 768px){
  .juslabore-footer{
    flex-wrap: wrap;
  }

  .footer-item{
    margin: 20px auto;
  }

  .w-25{
    width: 100%;
  }
}

.rt-tr-group {
  font-size: 14px;
  font-family: Verdana;
  text-align: center;
  cursor: pointer;
}

.rt-tr-group:nth-child(odd) {
  background-color: #d8d8d8;
}

.rt-tr-group:nth-child(even) {
  background-color: white;
}

.rt-thead {
  background-color: #333;
  font-size: 14px;
  font-family: Verdana;
  color: white;
}

.custom-modal {
  margin-top: 55px;
  z-index: 100;
}

.input-feedback {
  font-size: 12px;
  color: red;
}

.clipping-input {
  position: relative;
}

#processNumber {
  font-size: 16px;
  border: none;
  padding: 5px 0;
  width: 100%;
  transition: 0.2s ease;
}

/* label {
  bottom: 20px;
  left: 15px;
  transition: 0.2s ease;
  font-size: 12px;
} */

.field {
  display: flex;
  align-items: center;
}

.field label {
  margin: 0;
}

#processNumber {
  outline: none;

  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 94%, #3f51b5 6%);
  background-position: -400px 0;
  background-size: 400px 100%;
  background-repeat: no-repeat;
  border-bottom: 1px solid #aaa;

  &:focus {
    background-position: 0 0;
  }

  &:hover {
    border-bottom: 2px solid #000;
  }
}

#next-finish-button[disabled] {
  background-color: grey;
}

#next-finish-button {
  background-color: #2a5428;
}

label {
  color: #999;
  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;
}

#processNumber:focus + label {
  font-weight: bold;
  font-size: 8px;
  top: -10px;
  left: 7.5px;
  color: #3f51b5;
}

.px-3 {
  padding: 0px 14px 0px 0px !important;
}

.col-sm-1 {
  padding: 0px 5px;
}

.col-sm-2 {
  padding: 0px 5px;
}

.col-sm-3 {
  padding: 0px 5px;
}

.col-sm-4 {
  padding: 0px 5px;
}

[data-rmiz-btn-open] {
  cursor: zoom-in !important;
}
[data-rmiz-btn-close] {
  cursor: zoom-out !important;
}

.box-working-day {
  align-self: center;
  border-radius: 11px;
  margin: 2px;
  height: 30px;

  color: white;
}

.non-working-day {
  border: 6px solid #910;
  background-color: #910;
}

.working-day {
  border: 6px solid #185335;
  background-color: #185335;
}

`;
